import { ref as r } from "vue";
import { defineStore as t } from "pinia";
const a = "messaging", n = "/v1", c = t("lib-messaging", () => {
  const s = r([]);
  return {
    unreadMessages: s,
    updateUnreadMessages: async function() {
      const e = await this.$api.doNotCatchIfError().get(a, `${n}/channels/unread-count`);
      return Array.isArray(e) && (s.value = e), e;
    }
  };
});
export {
  c as u
};
